import React from 'react';
import { Dropdown, Form, Image, Overlay, Popover } from 'react-bootstrap';
import { connect, useDispatch } from 'react-redux';

import AuthButton from 'components/base/AuthButton';

import { switchOneOfSelectedList } from 'utils/MultiChoiceUtils';
import { createAction } from 'utils/index';

import arrowLeftToLineSvg from 'assets/images/arrow_left_to_line.svg';
import checkOnSvg from 'assets/images/check_on.svg';

import './MetricTableSideBar.scss';

const mapPropsToState = (state) => ({
  levels: state.metricTable.levels,
  selectedLevelIds: state.metricTable.selectedLevelIds,
  selectedStoreIds: state.metricTable.selectedStoreIds,
  timeRangeList: state.metricTable.timeRangeList,
});

function MetricTableSideBar({
  levels,
  selectedLevelIds,
  selectedStoreIds,
  timeRangeList,
  showSideBar,
  setShowSideBar,
}) {
  const dispatch = useDispatch();

  const [selectedIds, setSelectedIds] = React.useState(selectedLevelIds ?? []);
  React.useEffect(() => {
    setSelectedIds(selectedLevelIds);
  }, [selectedLevelIds, showSideBar]);

  const levelClicked = (levelId) => {
    console.log('levelClicked@', levelId);
    const newIds = switchOneOfSelectedList(selectedIds, levelId);
    setSelectedIds(newIds);
  };

  const refreshTableData = () => {
    dispatch(createAction('metricTable/getMetricTableData')());
  };

  const applyFilter = () => {
    dispatch(
      createAction('metricTable/updateMetricTableConfig')({
        selectedLevelIds: selectedIds,
        successAction: () => refreshTableData(),
      }),
    );
  };

  const clearFilter = () => {
    dispatch(
      createAction('metricTable/updateMetricTableConfig')({
        selectedLevelIds: [],
        successAction: () => refreshTableData(),
      }),
    );
  };

  return (
    <div
      className={`d-flex flex-column metric-table-side-bar ${
        showSideBar ? '' : 'compress'
      }`}
    >
      <div className="d-flex flex-row justify-content-between align-items-center">
        {showSideBar ? <div className="header-title">Filters</div> : null}
        <Image
          src={arrowLeftToLineSvg}
          className="side-bar-hide-btn"
          style={{
            transform: showSideBar ? 'rotate(0deg)' : 'rotate(180deg)',
          }}
          onClick={(e) => {
            e.preventDefault();
            setShowSideBar(!showSideBar);
          }}
        />
      </div>
      <div
        className={
          showSideBar
            ? 'd-flex flex-column filter-container'
            : 'filter-container hide-content'
        }
      >
        <div className="d-flex flex-column">
          <div className="filter-title">Customer tier</div>
          <div className="filter-checkbox-container">
            {levels?.map((levelData) => {
              console.log('levelData@', levelData);
              const { value } = levelData;
              const isChecked = selectedIds.includes(value);
              return (
                <div
                  className="d-flex flex-row justify-content-start align-items-start flex-gap-16"
                  key={value}
                  onClick={() => levelClicked(value)}
                >
                  {isChecked ? (
                    <div className="filter-checkbox checked">
                      <Image src={checkOnSvg} className="check-on-icon" />
                    </div>
                  ) : (
                    <div className="filter-checkbox" />
                  )}
                  <div className="filter-checkbox-label">{levelData.label}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {showSideBar ? (
        <div className="bottom-buttons">
          <AuthButton
            title="Apply Filters"
            className="btn-further"
            action={() => applyFilter()}
          />
          <AuthButton
            title="Clear All"
            className="btn-back-button-common"
            action={() => clearFilter()}
          />
        </div>
      ) : null}
    </div>
  );
}

export default connect(mapPropsToState)(MetricTableSideBar);
